import { Box, Typography } from '@mui/material';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { MixedChart } from '../../../components/Charts/MixedChart/MixedChart';
import { fundTransactionsFields } from '../../../schemas/FundContributions.schema';
import { cardStyles } from '../../../theme/component-styles';
import { formatFieldValue } from '../../../util/schema-utils';
import { NoDataMessage2 } from '../../CompanyProfiles/components/Messages/HelpMessage';
import { contributionsDistributionsState, selectedDateFPState } from '../state/FPState';
import {
  getContributionsDistributionsSeries,
  getLatestActivityPeriod,
  getTimeCategories,
  hasPlottableData,
} from './contributionsDistributionsUtils';
import { SummaryPanelBodyHeight } from './summaryPanelBodyHeight';

export const NoActivityMessage = 'No contributions or distributions in the selected period.';

export function ContributionsDistributions() {
  const contributionsDistributions = useAtomValue(contributionsDistributionsState);
  const asOfDate = useAtomValue(selectedDateFPState);
  const transactions = contributionsDistributions?.transactions;

  const xData = useMemo(() => getTimeCategories(asOfDate), [asOfDate]);
  const yData = useMemo(
    () => getContributionsDistributionsSeries(transactions ?? [], xData),
    [transactions, xData]
  );

  const emptyMessage = useMemo(() => {
    if (hasPlottableData(yData)) {
      return null;
    }
    const latestActivity = getLatestActivityPeriod(transactions ?? []);

    return latestActivity ? `${NoActivityMessage} Latest activity: ${latestActivity}.` : NoActivityMessage;
  }, [transactions, yData]);

  return (
    <div style={cardStyles}>
      <Typography variant={'body1'} my={'1rem'} component={'h6'}>
        Contributions/Distributions
      </Typography>
      <Box width={'100%'} height={SummaryPanelBodyHeight}>
        {emptyMessage ? (
          <NoDataMessage2 message={emptyMessage} />
        ) : (
          <MixedChart
            xCategoryData={xData}
            yValueData={yData}
            yAxis={{
              type: 'value',
              axisLabel: {
                formatter: (value: number | null) =>
                  formatFieldValue(fundTransactionsFields().amount, value, '-'),
              },
            }}
            staticOptions={{}}
          />
        )}
      </Box>
    </div>
  );
}
